// extracted by mini-css-extract-plugin
export default {"hint":"giga_hint__ZAlMc","firstBlock":"giga_firstBlock__oGMmN"};